import React, {useEffect, useState} from "react";
import {css} from "@emotion/css";
import {MawakibService} from "../../serverService/mawakibService/MawakibService";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {
    RaikoChipTypes,
    RaikoCustomSelect,
    RaikoCustomSimpleChip,
    RaikoFlexAlignStart,
    RaikoFlexFirstChildGrowOne,
    RaikoGridOneColumn,
    RaikoLabel,
    RaikoLabelType,
    RaikoSectionContainer,
    showServerErrorMessage,
    showSuccessMessage,
    raikoCustomSelectItemGenerator,
    RaikoChipSizeType,
    convertUniversalDateTimeToPersianDateTime,
    RaikoCardInfoTypeOne,RaikoCardInfoTypeOneItemGenerator,
    RaikoCardInfoTypeOneGridTypeItems
} from "@moeindal/base-raiko-panel-components";
import {Skeleton} from "@mui/material";
import {ServerErrorHandler} from "../../service/errorHandler/ServerErrorHandler";

export default function MawakibRegisterItemDetail({id, handleCloseDrawer, handleUpdateTable}) {

    const loading = new LoadingHelper(useLoadingDispatcher())

    const [loadingShimmer, setLoadingShimmer] = useState(false);
    const [mawakibInfo, setMawakibInfo] = useState(
        {
            "id": 0,
            "managerFirstName": "",
            "managerLastName": "",
            "managerPhoneNumber": "",
            "managerNationalCode": "",
            "timeOfService": "",
            "sendAt": "",
            "city": {
                "id": 0,
                "name": ""
            },
            "managerTelephone": "",
            "records": "",
            "offers": "",
            "location": {
                "id": 0,
                "title": ""
            },
            "services": [
                {
                    "id": 0,
                    "title": ""
                }
            ],
            "license": {
                "id": 0,
                "title": ""
            },
            "licenseNumber": "",
            "numberOfService": 0,
            "normalMeal": 0,
            "name": "",
            "status": "AWAITING_FOR_REVIEW"
        }
    );

    const [selectedRegisterState, setSelectedRegisterState] = useState("AWAITING_FOR_REVIEW");


    const service = new MawakibService()

    useEffect(() => {
        if (id !== -1){
            getMawakibRegisteredDetailFromServer()
        }
    }, [id]);


    function getMawakibRegisteredDetailFromServer() {
        setLoadingShimmer(true)
        service.getMawakibRegisteredDetail(id)
            .then(response => {
                setMawakibInfo(response)
                setSelectedRegisterState(response.status)
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            setLoadingShimmer(false)
        })
    }

    function handleUpdateRegisterState() {
        loading.show()

        service.updateRegisterState(id, selectedRegisterState)
            .then(response => {
                showSuccessMessage("تغییر وضعیت ثبت نام با موفقیت انجام شد.")
                handleUpdateTable(id, selectedRegisterState)
            }).catch(reason => {

            const serverError = new ServerErrorHandler(reason)
            if (serverError.getStatusCode() === 500)
                showServerErrorMessage("خطایی در سرور اتفاق افتاده است، لطفا با پشتیبان سیستم تماس حاصل فرمایید!")
            else
                showServerErrorMessage(serverError.getMessage(""))

        }).finally(_ => {
            loading.hide()
        })
    }

    function getTimeOfService(timeOfService) {
        let _state = ""

        switch (timeOfService) {
            case "ALL_DAY_OF_WEEK": {
                _state = "تمام هفته مقاومت"
                break;
            }
            case "ANNIVERSARY_BY_FRIDAY": {
                _state = "از روز سالگرد تا جمعه"
                break;
            }
            case "ON_THE_ANNIVERSARY_DAY": {
                _state = "فقط در روز سالگرد"
                break;
            }
            case "TWO_DAYS_A_WEEK": {
                _state = "دو روز در هفته مقاومت"
                break;
            }
            case "THREE_DAYS_A_WEEK": {
                _state = "سه روز در هفته مقاومت"
                break;
            }
            default: {
                _state = "نامشخص"
            }
        }

        return _state;
    }


    return (
        <div className={css`
            background: white;
            `}>
            {
                loadingShimmer ?
                    <RaikoGridOneColumn className={css`padding: 1rem;`}>
                        <Skeleton variant={"rounded"} className={css`padding: 64px`}/>
                        <Skeleton variant={"rounded"} className={css`padding: 32px`}/>
                        <Skeleton variant={"rounded"} className={css`padding: 32px`}/>
                        <Skeleton variant={"rounded"} className={css`padding: 64px`}/>
                        <Skeleton variant={"rounded"} className={css`padding: 32px`}/>
                    </RaikoGridOneColumn> :
                    <RaikoGridOneColumn>
                        <RaikoFlexFirstChildGrowOne className={css`height: fit-content;
                            position: sticky;
                            z-index: 1;
                            top: 0;
                            background: #ffffff;
                            padding: 1rem;
                        `}>
                            <RaikoLabel text={mawakibInfo.name} raikoLabelType={RaikoLabelType.TITLE}/>
                            <div className={"ic-close"} onClick={handleCloseDrawer}/>
                        </RaikoFlexFirstChildGrowOne>
                        <RaikoGridOneColumn className={css`padding: 1rem;;height: 100%; overflow-y: scroll;scrollbar-width: none;`}>
                            <RaikoCardInfoTypeOne
                                title={"جزئيات موکب"}
                                items={[
                                    RaikoCardInfoTypeOneItemGenerator("نام موکب", mawakibInfo.name),
                                    RaikoCardInfoTypeOneItemGenerator("تاریخ ثبت", mawakibInfo.sendAt ? convertUniversalDateTimeToPersianDateTime(mawakibInfo.sendAt) : "-"),
                                    RaikoCardInfoTypeOneItemGenerator("محل استقرار", mawakibInfo.location ? mawakibInfo.location.title : ""),
                                    RaikoCardInfoTypeOneItemGenerator("نوع مجوز", mawakibInfo.license ? mawakibInfo.license.title : ""),
                                    RaikoCardInfoTypeOneItemGenerator("شماره مجوز", mawakibInfo.licenseNumber ? mawakibInfo.licenseNumber : "ندارد"),
                                    RaikoCardInfoTypeOneItemGenerator("تعداد خدمت ( نفر در روز )", mawakibInfo.numberOfService),
                                    RaikoCardInfoTypeOneItemGenerator("دوره خدمت رسانی", getTimeOfService(mawakibInfo.timeOfService)),
                                ]}
                                gridTypeItems={RaikoCardInfoTypeOneGridTypeItems.FOUR_COLUMN}

                            />
                            <RaikoCardInfoTypeOne
                                title={"جزئیات مدیر"}
                                items={[
                                    RaikoCardInfoTypeOneItemGenerator("نام مدیر", mawakibInfo.managerFirstName),
                                    RaikoCardInfoTypeOneItemGenerator("نام خانوادگی مدیر", mawakibInfo.managerLastName),
                                    RaikoCardInfoTypeOneItemGenerator("شماره تماس", mawakibInfo.managerPhoneNumber),
                                    RaikoCardInfoTypeOneItemGenerator("کدملی", mawakibInfo.managerNationalCode),
                                    RaikoCardInfoTypeOneItemGenerator("شهر", mawakibInfo.city ? mawakibInfo.city.name : ""),
                                ]}
                                gridTypeItems={RaikoCardInfoTypeOneGridTypeItems.FOUR_COLUMN}
                            />

                            <RaikoCardInfoTypeOne
                                title={"جزئیات خدمات"}
                                gridTypeItems={RaikoCardInfoTypeOneGridTypeItems.TWO_COLUMN}
                                hasColumnDirectionItems={true}
                                items={[
                                    RaikoCardInfoTypeOneItemGenerator("نوع خدمات",
                                        <RaikoFlexAlignStart>{mawakibInfo.services && mawakibInfo.services.map((item, index) => {
                                            return <RaikoCustomSimpleChip size={RaikoChipSizeType.small} title={item.title} type={RaikoChipTypes.primary}/>
                                        })}</RaikoFlexAlignStart>),
                                    RaikoCardInfoTypeOneItemGenerator("سوابق موکب", mawakibInfo.records),
                                    RaikoCardInfoTypeOneItemGenerator("پیشنهادات", mawakibInfo.offers),
                                    RaikoCardInfoTypeOneItemGenerator("خدمات قابل ارائه", mawakibInfo.serviceDescription),
                                ]}
                            />
                            <RaikoSectionContainer
                                title={"وضعیت ثبت نام"}
                                subTitle={" با اولین بار تغییر وضعیت ثبت نام به 'پذیرفته شده' پیامک تایید ثبت نام به همراه لینک گروه ایتا برای کاربر ارسال خواهد شد."}
                                hasActionButton
                                actionButtonTitle={"بروزرسانی"}
                                actionButtonOnclick={handleUpdateRegisterState}
                            >
                                <RaikoCustomSelect
                                    labelText={"وضعیت ثبت نام"}
                                    value={selectedRegisterState}
                                    setValue={setSelectedRegisterState}
                                    items={[
                                        raikoCustomSelectItemGenerator("AWAITING_FOR_REVIEW", "در حال بررسی"),
                                        raikoCustomSelectItemGenerator("ACCEPTED", "پذیرفته شده"),
                                        raikoCustomSelectItemGenerator("REJECTED", "رد شده")
                                    ]}
                                />

                            </RaikoSectionContainer>
                        </RaikoGridOneColumn>

                    </RaikoGridOneColumn>
            }

        </div>
    )
}